import { render, staticRenderFns } from "./hot-tip.vue?vue&type=template&id=5cdd4163&scoped=true&"
import script from "./hot-tip.vue?vue&type=script&lang=js&"
export * from "./hot-tip.vue?vue&type=script&lang=js&"
import style0 from "./hot-tip.vue?vue&type=style&index=0&id=5cdd4163&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdd4163",
  null
  
)

export default component.exports